import { ALERT_SETTINGS_TOGGLE_RIGHTPANEL, ALERT_SETTINGS_UPDATE_CHANNELS, ALERT_SETTINGS_UPDATE_MANAGE } from './types';

import * as moment from 'moment';

  export const navigate = (ref: any) => {
    const { pathname, history } = ref;
    history.push(pathname);
  };
  
  export const toggleRightPanel = (ref: any) => {
    const { dispatch, rightPanelExpanded } = ref;
    dispatch({
      type: ALERT_SETTINGS_TOGGLE_RIGHTPANEL,
      payload: !rightPanelExpanded
    });
  };

  export const addChannelItem = (ref: any) => {
    const { dispatch, channels, accountType } = ref;
    const date =  moment(new Date()).format('L');
    const accountLength = channels[accountType].list.length + 1;
    const id = Math.floor(Math.random()*(999-100+1)+100).toString();
    const account = {
      date,
      id,
      name: 'account_' + accountLength,
      preSelected: true,
      trackLikes: true,
      active: true
    };
    channels[accountType].list.push(account);
    updateAlertChannelSettings({ dispatch, channels });
  };

  export const initializeGroupItem = () => {
    const date =  moment(new Date()).format('L');
    const id = Math.floor(Math.random()*(999-100+1)+100).toString();
    const listItem = {
      checked: true,
      active: true,
      date,
      id,
      title: '',
      description: '',
      members: [],
      membersStr: '',
      type: "public"
    };
    return listItem;
    };

  export const addManageInnerItem = (ref: any) => {
    const { dispatch, manage, itemType } = ref;
    const date =  moment(new Date()).format('L');
    const id = Math.floor(Math.random()*(999-100+1)+100).toString();
    const listItem = {
      checked: true,
      active: true,
      initials: 'J.S',
      title: 'Jason Smith',
      date,
      id,
    };
    const itemIndex = getManageItemIndex(ref);
    manage[itemType].list[itemIndex].members.push(listItem);
    updateAlertManageSettings({ dispatch, manage });
  };

  export const inviteGroupMembers = (ref: any) => {
    const { group } = ref;
    const date =  moment(new Date()).format('L');
    const id = Math.floor(Math.random()*(999-100+1)+100).toString();
    const listItem = {
      checked: true,
      active: true,
      initials: 'J.S',
      title: 'Jason Smith',
      date,
      id,
    };
    group.members.push(listItem);
    return group;
  };

  export const getAccount = (ref: any) => {
    const { channels, accountType, accountId } = ref;
    const list = channels[accountType].list;
    const item = list.filter((account: any) => {
      return account.id === accountId
    })[0];
    return item;
  };

  export const getAccountIndex = (ref: any) => {
    const { channels, accountType, accountId } = ref;
    const accounts = channels[accountType].list;
    const index = accounts.findIndex((account:any) => account.id === accountId);
    return index;
  };

  export const getManageItem = (ref: any) => {
    const { manage, itemType, itemId } = ref;
    const list = manage[itemType].list;
    const item = list.filter((listItem: any) => {
      return listItem.id === itemId
    })[0];
    return item;
  };

  export const getManageItemIndex = (ref: any) => {
    const { manage, itemType, itemId } = ref;
    const list = manage[itemType].list;
    const index = list.findIndex((item:any) => item.id === itemId);
    return index;
  };

  export const changeChannelAccountName = (ref: any) => {
    const { dispatch, index, channels, accountType, name } = ref;
    channels[accountType].list[index].name = name;
    updateAlertChannelSettings({ dispatch, channels });
  };

  export const changeManageItemStatus = (ref: any) => {
    const { dispatch, manage, status, itemId, itemType, history } = ref;
    const item = manage[itemType].list;
    if(status === 'deactivate' || status === 'activate'){
      ref.detailToChange = 'active';
      changeManageAccountDetails(ref);
    }
    else if(status === 'delete'){
      const index = getManageItemIndex(ref);
      item.splice(index, 1);
    }
    else if(status === 'edit') {
      const pathname = '/alerts-settings/' + itemType + `/edit/${itemId}`;
      navigate({ pathname, history });
    }
    updateAlertManageSettings({ dispatch, manage })
  };

  export const changeChannelAccountStatus = (ref: any) => {
    const { dispatch, channels, status, accountId, accountType, history } = ref;
    const accounts = channels[accountType].list;
    
    if(status === 'deactivate' || status === 'activate'){
      ref.detailToChange = 'active';
      changeChannelAccountDetails(ref)
    }
    else if(status === 'delete'){
      // delete account
      const index = getAccountIndex(ref);
      accounts.splice(index, 1);
    }
    else if(status === 'edit') {
      // navigate to screen;
      const pathname = '/alerts-settings/' + accountType + `/edit/${accountId}`;
      navigate({ pathname, history })
    }
    updateAlertChannelSettings({ dispatch, channels });
  };

  export const changeChannelAccountDetails = (ref: any) => {
    const { dispatch, channels, detailToChange } = ref;
    const account = getAccount(ref);
    account[detailToChange] = !account[detailToChange];
    updateAlertChannelSettings({ dispatch, channels });
  }

  export const changeManageAccountDetails = (ref: any) => {
    const { dispatch, manage, detailToChange } = ref;
    const item = getManageItem(ref);
    item[detailToChange] = !item[detailToChange];
    updateAlertManageSettings({ dispatch, manage })
  }

  export const saveChanges = (ref: any) => {
    const { dispatch, alertSettings, alertSettingsType, updatedObj } = ref;
    if(alertSettingsType === 'channels'){
      let channels = alertSettings[alertSettingsType];
      channels = updatedObj;
      updateAlertChannelSettings({ dispatch, channels });
      navigate(ref);
    }
    else if(alertSettingsType === 'manage'){
      let manage = alertSettings[alertSettingsType];
      manage = updatedObj;
      updateAlertManageSettings({ dispatch, manage });
      navigate(ref);
    }
  }

  export const changeChannelStatus = (ref: any) => {
    const { dispatch, channels, channelType } = ref;
    channels[channelType].status = !channels[channelType].status;
    updateAlertChannelSettings({ dispatch, channels });
  };

  export const manageCheckBoxChanged = (ref: any) => {
    const { dispatch, manage, itemType } = ref;
    const index = getManageItemIndex(ref);
    manage[itemType].list[index].checked = !manage[itemType].list[index].checked;
    updateAlertManageSettings({ dispatch, manage });
  };

  export const manageListChanged = (ref: any) => {
    const { dispatch, manage, itemType, list } = ref;
    manage[itemType].list = list;
    updateAlertManageSettings({ dispatch, manage });
  };

  const updateAlertChannelSettings = (ref: any) => {
    const { dispatch, channels } = ref;
    const newSettingsChannels = JSON.parse(JSON.stringify(channels));
    dispatch({
      type: ALERT_SETTINGS_UPDATE_CHANNELS,
      payload: newSettingsChannels
    });
  }

  const updateAlertManageSettings = (ref: any) => {
    const { dispatch, manage } = ref;
    const newSettingsManage = JSON.parse(JSON.stringify(manage));
    dispatch({
      type: ALERT_SETTINGS_UPDATE_MANAGE,
      payload: newSettingsManage
    });
  }



// WEBPACK FOOTER //
// ./src/actions/alert-settings/alert-settings-api.tsx